import { TaxGateway, CreateCalcTaxNFDto } from '../domain/tax.gateway';

export class CalcTaxNFUseCase {
    constructor(private gate: TaxGateway) {}

    async execute(params: CreateCalcTaxNFDto): Promise<number> {
        return this.gate.calcTaxNF(params);
    }
}
